import { useState } from 'react';

import { Grid, NoSsr } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import { CardBase, DescriptionListIcon } from '@/src/components/organisms';

import Menu from './Menu';

const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(3, 0),
  },
  featureItems: {
    width: '100%',
    height: '100%',
    background: 'url(/bg-shapes.svg) no-repeat top center',
    backgroundSize: 'contain',
  },
  card: {
    cursor: 'pointer',
    borderTop: `8px transparent solid`,
    borderRadius: theme.spacing(2),
    transition: theme.transitions.create('all', {
      duration: theme.transitions.duration.complex,
    }),
  },
  iconCover: {
    width: 60,
    height: 60,
    background: 'url(/bgicon.svg) no-repeat center center',
    backgroundSize: 'contain',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 35,
    [theme.breakpoints.up('md')]: {
      width: 80,
      height: 80,
      fontSize: 50,
    },
  },
  familiesIcon: {
    color: theme.palette.branding.red.main,
  },
  institutionsIcon: {
    color: theme.palette.branding.blue.main,
  },
  sellersIcon: {
    color: theme.palette.branding.yellow.main,
  },
  familiesAvatar: {
    backgroundColor: theme.palette.branding.red.main,
  },
  institutionsAvatar: {
    backgroundColor: theme.palette.branding.blue.main,
  },
  sellersAvatar: {
    backgroundColor: theme.palette.branding.yellow.main,
  },
  familiesCard: {
    borderTopColor: theme.palette.branding.red.main,
  },
  institutionsCard: {
    borderTopColor: theme.palette.branding.blue.main,
  },
  sellersCard: {
    borderTopColor: theme.palette.branding.yellow.main,
  },
}));

const options = {
  families: [
    {
      label: 'Encontre lojas',
      href: '/explore',
      icon: 'fas fa-search-location',
    },
    {
      label: 'Cadastrar nova conta',
      href: '/sign-up',
      icon: 'fas fa-user-plus',
    },
    {
      label: 'Acompanhe pedidos',
      href: '/orders',
      icon: 'fas fa-box',
    },
  ],
  institutions: [
    {
      label: 'Escolas de educação básica',
      href: '/solutions/k-12',
      icon: 'fas fa-school',
    },
    {
      label: 'Escolas de idiomas',
      href: '/solutions/language-schools',
      icon: 'fas fa-language',
    },
    {
      label: 'Faculdades e universidades',
      href: '/solutions/colleges',
      icon: 'fas fa-graduation-cap',
    },
    {
      label: 'Grupos educacionais',
      href: '/solutions/educational-groups',
      icon: 'fas fa-building',
    },
  ],
  sellers: [
    {
      label: 'Editoras e sistemas de ensino',
      href: '/solutions/publishers',
      icon: 'fas fa-book',
    },
    {
      label: 'Cursos livres e complementares',
      href: '/solutions/after-school',
      icon: 'fas fa-chalkboard-teacher',
    },
    {
      label: 'Confecções, livrarias e papelarias',
      href: '/solutions/retail',
      icon: 'fas fa-tshirt',
    },
    {
      label: 'Soluções e plataformas digitais',
      href: '/solutions/digital-platforms',
      icon: 'fas fa-cloud',
    },
  ],
};

const Personas = props => {
  const { className, ...rest } = props;

  const classes = useStyles();
  const [families, setFamilies] = useState(false);
  const [institutions, setInstitutions] = useState(false);
  const [sellers, setSellers] = useState(false);

  const features = {
    items: [
      // {
      //   icon: 'fas fa-user-graduate',
      //   title: 'Consumidores',
      //   subtitle: 'Precisa comprar algum produto ou serviço educacional?',
      //   iconClassName: classes.familiesIcon,
      //   cardClassName: classes.familiesCard,
      //   onClick: () => setFamilies(true),
      // },
      {
        icon: 'fas fa-school',
        title: 'Instituições',
        subtitle: 'Quer abrir sua loja online gratuitamente?',
        iconClassName: classes.institutionsIcon,
        cardClassName: classes.institutionsCard,
        onClick: () => setInstitutions(true),
      },
      {
        icon: 'fas fa-building',
        title: 'Fornecedores',
        subtitle: 'Quer vender na loja online das instituições de ensino?',
        iconClassName: classes.sellersIcon,
        cardClassName: classes.sellersCard,
        onClick: () => setSellers(true),
      },
    ],
  };

  const { items } = features;

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <Grid container>
        <Grid item xs={12} data-aos="fade-up">
          <div className={classes.featureItems}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  {items.map((item, index) => (
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={6}
                      xs={12}
                      key={index.toString()}
                      data-aos="zoom-out-up">
                      <CardBase
                        withShadow
                        liftUp
                        onClick={item.onClick}
                        className={clsx(classes.card, item.cardClassName)}>
                        <DescriptionListIcon
                          icon={
                            <div className={clsx(classes.iconCover, item.iconClassName)}>
                              <NoSsr>
                                <i className={item.icon} />
                              </NoSsr>
                            </div>
                          }
                          title={item.title}
                          subtitle={item.subtitle}
                        />
                      </CardBase>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
      <Menu
        open={families}
        onClose={() => setFamilies(false)}
        className={classes.familiesCard}
        AvatarProps={{ className: classes.familiesAvatar }}
        title="Consumidores educacionais"
        subtitle="Caso precise comprar ou já tenha comprado em uma das lojas em nossas plataforma, utilize alguma das opções abaixo."
        options={options.families}
        loginHref="/families"
      />
      <Menu
        open={institutions}
        onClose={() => setInstitutions(false)}
        className={classes.institutionsCard}
        AvatarProps={{ className: classes.institutionsAvatar }}
        title="Instituições de ensino"
        subtitle="Ainda não possui a loja online da sua instituição em nossa plataforma?"
        options={options.institutions}
        demoHref="/schedule?utm_campaign=home&utm_content=institutions"
        loginHref="/institutions"
      />
      <Menu
        open={sellers}
        onClose={() => setSellers(false)}
        className={classes.sellersCard}
        AvatarProps={{ className: classes.sellersAvatar }}
        title="Fornecedores educacionais"
        subtitle="Gostaria de começar a vender para as lojas onlines das instituições de ensino em nossa plataforma?"
        options={options.sellers}
        demoHref="/schedule?utm_campaign=home&utm_content=sellers"
        loginHref="/sellers"
      />
    </div>
  );
};

Personas.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Personas;
